import type { ZodNumberCheck } from 'zod'

import { getEnumValuesFromPipelineSchema } from '@flows/configs/shared/schemaUtils'
import { BaseSchema_HouseholdV1GetsafeAt as schema } from '@flows/insurance/schemas'
import { getClaimsOptions } from '@flows/insurance/utils/stepContentUtils'

const deductiblesOptionsFromSchema = getEnumValuesFromPipelineSchema(schema.shape.deductible_amount)
const claimsOptionsFromSchema = getEnumValuesFromPipelineSchema(
  schema.shape.number_of_previous_claims.unwrap()
)

export const HOUSEHOLD_AT_CONSTANTS = {
  deductibleOptions: deductiblesOptionsFromSchema,
  furnishing_options: schema.shape.furnishing_level.options,
  cohabitants_types: schema.shape.cohabitation_type.options,
  squareMetersValidation: {
    min: schema.shape.square_meters
      .innerType()
      ._def.checks.find((check): check is ZodNumberCheck & { kind: 'min' } => check.kind === 'min')
      ?.value,
    max: schema.shape.square_meters
      .innerType()
      ._def.checks.find((check): check is ZodNumberCheck & { kind: 'max' } => check.kind === 'max')
      ?.value,
  },
  maxCustomerAge: 120,
  claimsOptions: getClaimsOptions(claimsOptionsFromSchema.length),
  multiplier_values: {
    simple: 700,
    comfortable: 850,
    upscale: 1100,
  },
}

export const HOUSEHOLD_STEPS = {
  household_at_zip: 'household_at_zip',
  household_at_square_meters: 'household_at_square_meters',
  household_at_furnishing_level: 'household_at_furnishing_level',
  household_at_cohabitation_type: 'household_at_cohabitation_type',
  household_at_deductible_amount: 'household_at_deductible_amount',
  household_at_cohabitants: 'household_at_cohabitants',
  household_at_born_on: 'household_at_born_on',
  household_at_quote: 'household_at_quote',
  household_at_flood_area: 'household_at_flood_area',
  household_at_prev_insurance: 'household_at_prev_insurance',
  household_at_number_of_previous_claims: 'household_at_number_of_previous_claims',
  household_at_contact_details: 'household_at_contact_details',
  household_at_personal: 'household_at_personal',
  household_at_statement_of_fact: 'household_at_statement_of_fact',
  postQuoteStep: 'postQuoteStep',
}

export const validationTranslationParams = {
  square_meters: {
    min: {
      type: 'staticValue',
      value: String(HOUSEHOLD_AT_CONSTANTS.squareMetersValidation.min),
    },
    max: {
      type: 'staticValue',
      value: String(HOUSEHOLD_AT_CONSTANTS.squareMetersValidation.max),
    },
  },
} as const
